import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import {
    kBalanceRange,
    kComplexity40Range,
    kPitchPaletteLength,
    kVariationRange,
} from "@/shared/magic-fit-4.0.api";
import { isObject } from "@/shared/utils/typeGuards";

export const kMagicFit40FastRoute = "/magic-fit-4.0-fast";

// The 4.0 fast app maps balance onto its 8-step PingPong sampler so the
// guidance it applies matches what 4.0's 32-step Euler applies at the same
// value, so 4.0's defaults, balance included, carry over unchanged.
export { kBalanceRange, kComplexity40Range, kPitchPaletteLength, kVariationRange };

export interface MagicFit40FastRequestBody {
    drivingAudioKey: string;
    timbreAudioKey: string;
    bpm: number;
    pitchPalette?: number[];
    variation?: number;
    balance?: number;
    complexity?: number;
}

export const isMagicFit40FastRequestBody = (value: unknown): value is MagicFit40FastRequestBody =>
    isObject(value) &&
    typeof value.drivingAudioKey === "string" &&
    typeof value.timbreAudioKey === "string" &&
    typeof value.bpm === "number";

export const kMagicFit40FastEndpoint: ApiEndpoint<MagicFit40FastRequestBody, DownloadUrlResponse> =
    {
        route: kMagicFit40FastRoute,
        label: "Magic Fit 4.0 fast",
        source: "Modal",
        isEvaluationOnly: true,
        category: "SpliceGen v4.0 fast",
        description:
            "Magic Fit using a faster version of the SpliceGen 4.0 model with complexity control over the timbre transfer.",
        isRequestBody: isMagicFit40FastRequestBody,
        isSuccessResponse: isDownloadUrlResponse,
    };
